import { ConfluenceIcon } from '@atlaskit/logo';

import {
	DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI,
	DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
	DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI,
} from '../../entities';
import {
	NounSubtypeKey,
	type TypeFilterConfig3P,
	TypeFilterValueKey,
} from '../../filters/universal-type';
import { RovoLogoFromLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

export const confluenceDCConfig: ThirdPartyConfig = {
	displayName: 'Confluence Data Center',
	id: 'confluence-dc',
	resourceType: 'confluence-dc-connector',
	icon: RovoLogoFromLogo(ConfluenceIcon, 'Confluence Data Center'),
	searchResultIcon: RovoLogoFromLogo(ConfluenceIcon, 'large'),
	integrationAri: 'ari:cloud:platform::integration/confluence-dc',
	typeFilterConfig: (() => {
		const typeFilter: TypeFilterConfig3P = new Map([
			[
				TypeFilterValueKey.Space,
				{
					entities3P: DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI,
					subTypes3P: [NounSubtypeKey.Space],
				},
			],
			[
				TypeFilterValueKey.Page,
				{
					entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
					subTypes3P: [NounSubtypeKey.Page],
				},
			],
			[
				TypeFilterValueKey.Blogpost,
				{
					entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
					subTypes3P: [NounSubtypeKey.Blogpost],
				},
			],
			[
				TypeFilterValueKey.Comment,
				{
					entities3P: DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI,
					subTypes3P: [],
				},
			],
			[
				TypeFilterValueKey.Attachment,
				{
					entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
					subTypes3P: [
						NounSubtypeKey.Archive,
						NounSubtypeKey.Audio,
						NounSubtypeKey.Code,
						NounSubtypeKey.Document,
						NounSubtypeKey.Image,
						NounSubtypeKey.Pdf,
						NounSubtypeKey.Presentation,
						NounSubtypeKey.Spreadsheet,
						NounSubtypeKey.Video,
						NounSubtypeKey.WebPage,
						NounSubtypeKey.Other,
					],
				},
			],
		]);
		return typeFilter;
	})(),
	filters: ['lastUpdated', 'onlyTitleMatch', 'createdBy', 'content', 'space', 'label'],
	requiresOauth: true,
	isEnabled: () => true,
	displayWorkspaceNameAsProductName: true,
};
